import React, { useEffect, useState } from "react";
import { Col, Card, CardBody, Input, Row } from "reactstrap";
import { api } from "../utils";
import { DesktopContainer } from "../layouts";
import { toast } from "react-toastify";
import { SpinnerButton } from '.';

export default function ResetCaseStatus() {
  const [caseId, setCase] = useState("");
  const [loading, setLoading] = useState(false);
  const [lot, setLot] = useState("");
  
  useEffect(() => {
    if (loading) {
      var caseNum = caseId === "" ? "0" : caseId;
      var wo = lot === "" ? "x" : lot;
       api
         .post(`Production/ResetCase/${caseNum}/${wo}`)
         .then(response => {
           if (response.data.success) {
             toast.success(response.data.message);
             setCase("");
             setLot("")
           }
           else {
             toast.error(response.data.message);
           }
         })
         .catch((error) => {
           api.catchHandler(error);
         })
         .finally(() => {
           setLoading(false);
         })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])


  return (
    <DesktopContainer screenName="Reset Case Status">
      <Card className="dashboard-card">
        <CardBody>
          <div>
            <span className="h2 me-2">Reset Case Status to Added to Inventory</span>
          </div>
          <hr />
          <Row className="mt-3 d-flex justify-content-center align-items-center">
            <Col xs="6">
              <Row className="mt-3 d-flex align-item-center">
                <Col xs="3" className="d-flex justify-content-end">
                  <p className="m-0" style={{ fontSize: "1.25rem" }}>Case #:</p>
                </Col>
                <Col xs="7">
                  <Input
                    type="text"
                    value={caseId}
                    onChange={(e) => setCase(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className="mt-3 d-flex align-item-center">
                <Col xs="3" className="d-flex justify-content-end">
                  <p className="m-0" style={{ fontSize: "1.25rem" }}>WO #:</p>
                </Col>
                <Col xs="7">
                  <Input
                    type="text"
                    value={lot}
                    onChange={(e) => setLot(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className="mt-3 d-flex align-items-center">
                <Col xs="3">
                </Col>
                <Col xs="9">
                  <SpinnerButton className="shredButton" onClick={() => setLoading(true)} on={loading} disabled={loading}>
                    RESET CASE
                  </SpinnerButton>
                 </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </DesktopContainer>
  );
}
